<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.programacao.string001" />
      <v-divider />

      <div class="ma-5">
        <v-card
          outlined
          elevation="0"
        >
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              hide-default-footer
            >
            <template v-slot:[`item.dtIniPeriodo`]="{ item }">
              {{ moment(item.dtIniPeriodo).format("DD/MM/YYYY") }}
            </template>

            <template v-slot:[`item.dtFimPeriodo`]="{ item }">
              {{ moment(item.dtFimPeriodo).format("DD/MM/YYYY") }}
            </template>

            <template v-slot:[`item.dtIniFerias`]="{ item }">
              {{ moment(item.dtIniFerias).format("DD/MM/YYYY") }}
            </template>

            <template v-slot:[`item.dtFimFerias`]="{ item }">
              {{ moment(item.dtFimFerias).format("DD/MM/YYYY") }}
            </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
export default {
  data: () => ({
    snackbar: false,
    loading: false,
    headers: [
      {
        text: "Matrícula",
        value: "codEmpregado",
        divider: true,
      },
      {
        text: "Nome",
        value: "nome",
        divider: true,
      },
      {
        text: "Início Período",
        value: "dtIniPeriodo",
        divider: true,
      },
      {
        text: "Fim Período",
        value: "dtFimPeriodo",
        divider: true,
      },
      {
        text: "Início das Férias",
        value: "dtIniFerias",
        divider: true,
      },
      {
        text: "Final das Férias",
        value: "dtFimFerias",
        divider: true,
      },
      {
        text: "Dias de Férias",
        value: "diasFerias",
        divider: true,
      },
      {
        text: "Dias de Abono",
        value: "diasAbono",
        divider: true,
      },
    ],
    items: [],
  }),
  async mounted() {
    const service = new Service();
    this.items = await service.buscaProgramacaoFerias();
  },
  computed: {
  },
  methods: {
  },
};
</script>
